import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { ActivityReorderComponent } from './activity-reorder.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AccessibleDropListModule } from '@go-modules/directives/accessible-drop-list/accessible-drop-list.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		DragDropModule,
		AccessibleDropListModule
	],
	declarations: [
		ActivityReorderComponent
	],
	exports: [
		ActivityReorderComponent
	]
})
export class ActivityReorderModule {}
